import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=1b4527b4&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=1b4527b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4527b4",
  null
  
)

export default component.exports